import { defineComponent, PropType } from "@vue/composition-api";
import { TruckLoadLineItem } from "@/models/TruckLoadLineItem";

export default defineComponent({
  name: "truckLoadLineItemPartial",
  props: {
    lnItem: {
      type: Object as PropType<TruckLoadLineItem>,
      required: true,
    },
  },

  setup(_props, _ctx) {
    return {};
  },
});
